import { render, staticRenderFns } from "./delete-widget-modal.vue?vue&type=template&id=06ac2797"
import script from "./delete-widget-modal.vue?vue&type=script&lang=js"
export * from "./delete-widget-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports